<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
          v-on="on"
          text
          depressed
      >
        <span class="pr-1  hidden-xs-only">{{ establecimiento.nombre }}</span>
      </v-btn>
    </template>
    <v-list v-if="filteredEstablecimientoList.length !== 0" class="fh-menu-scroll">
      <template v-if="filteredEstablecimientoList.length !== 0">
        <v-list-item
            v-for="(establecimiento,e) in filteredEstablecimientoList"
            :key="`${establecimiento.idEstablecimiento}${e}`"
            @click="handleElegirEstablecimiento(establecimiento)"
        >
          <v-list-item-title>{{ establecimiento.nombre }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
  name: 'FhMenuEstablecimiento',
  data: () =>({
  
  }),
  computed: {
    ...mapState('session', [
      'isRestored',
    ]),
    ...mapState('agricultor', [
      'agricultor'
    ]),
    ...mapState('establecimientos', [
      'establecimiento',
      'establecimientosList',
    ]),
    ...mapGetters('establecimientos',[
      'filteredEstablecimientoList',
      'currentCategoria'
    ]),
  },
  methods: {
    ...mapActions('establecimientos',[
      'clearEstablecimiento',
      'setEstablecimiento',
      'fetchEstablecimientosListSimple'
    ]),
    async handleElegirEstablecimiento(establecimiento){
      await this.clearEstablecimiento()
      await this.setEstablecimiento(establecimiento)
      if(this.currentCategoria === 1){
        this.$router.push({name: 'AgroHome'}).catch(() => {})
      }
      else{
        this.$router.push({name: 'GanaderiaHome'}).catch(() => {})
      }
    },
  },
  async created (){
    // To prevent a race condition when session isn't restored yet
    while (!this.isRestored && !this.establecimiento.idEstablecimiento) {
      await this.$sleep(10)
    }
    await this.fetchEstablecimientosListSimple(this.agricultor.idAgricultor)
  },
}
</script>